<div class="chart-container" style="height: 260px">
    <canvas id="{{ this.chartId }}">{{ chart }}</canvas>
</div>
